import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { IconSize } from '../../../Icons/IconWrap';
import ConditionalTooltip from '../ConditionalTooltip';
import NewContentIndicator from '../NewContentIndicator';
import BiLink from '../../../biLogger/Components/BiLink';
import { BiEventType } from '../../../biLogger/constants';
import IconButtonWithContextMenu from '../../../Dropdown/Preset/IconButtonWithContextMenu';
import MoreIcon from '../../../Icons/Ellipsis';
import s from './NetworkBarLink.scss';
var NetworkBarLink = function (_a) {
    var label = _a.label, Icon = _a.icon, url = _a.url, tabIndex = _a.tabIndex, isSelected = _a.isSelected, _b = _a.isCollapsed, isCollapsed = _b === void 0 ? false : _b, _c = _a.hasNewContent, hasNewContent = _c === void 0 ? false : _c, className = _a.className, menuItems = _a.menuItems;
    var t = useTranslation().t;
    var _d = useState(false), isActionsDropdownOpen = _d[0], setActionsDropdownOpen = _d[1];
    var toggleDropdown = useCallback(function () { return setActionsDropdownOpen(function (isOpen) { return !isOpen; }); }, []);
    return (React.createElement(ConditionalTooltip, { tooltipContent: t("networkBar.navItems." + label + ".tooltip"), showTooltip: isCollapsed },
        React.createElement("div", { className: classnames(s['root'], isSelected && s['selected'], isActionsDropdownOpen && s['actions-open'], className) },
            React.createElement(BiLink, { href: url, className: s['item-link'], tabIndex: tabIndex, biData: {
                    evid: BiEventType.NETWORK_BAR_NAV_CLICK,
                    sectionname: label,
                    indicator: hasNewContent ? 1 : 0,
                    is_expanded: isCollapsed ? 0 : 1,
                } },
                React.createElement("div", { className: s['icon-wrapper'] },
                    React.createElement(Icon, { disableDefaultColors: true, size: IconSize.MEDIUM, className: s['icon'] }),
                    hasNewContent && (React.createElement(NewContentIndicator, { className: s['highlight'], bottomCircleClassName: s['highlight-bottom'] }))),
                !isCollapsed && (React.createElement("span", { className: s['label'] }, t("networkBar.navItems." + label)))),
            menuItems && (React.createElement(IconButtonWithContextMenu, { className: s['actions'], popperClassName: "networkbar-group-dropdown", withButton: true, noIconHoverEffect: true, items: menuItems, onToggle: toggleDropdown, isInPopup: true, usePortal: true, biData: isActionsDropdownOpen
                    ? undefined
                    : {
                        evid: BiEventType.NETWORK_BAR_3DOTS_OPEN,
                        sectionname: label,
                        indicator: hasNewContent ? 1 : 0,
                    } },
                React.createElement(MoreIcon, { disableDefaultColors: true }))))));
};
NetworkBarLink.displayName = 'NetworkBarLink';
export default NetworkBarLink;
//# sourceMappingURL=NetworkBarLink.js.map